import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import creator from 'utils/action-creator';
import axios from 'utils/axios';

/**
 * Utils
 */
import { CURRENT_YEAR, CURRENT_MONTH } from 'utils/selectOptionsUtils';
import serializeToQueryString from 'utils/serializeToQueryString';

/**
 * External Ations
 */

/**
 * Constants
 */
export const REQUEST = '@app/timesheetworkersaga/REQUEST';
export const INIT_REUQEST = '@app/timesheetworkersaga/INIT_REUQEST';
export const SUCCESS = '@app/timesheetworkersaga/SUCCESS';
export const FAILURE = '@app/timesheetworkersaga/FAILURE';
export const SET_LOADING = '@app/timesheetworkersaga/SET_LOADING';
export const SET_ITEMS = '@app/timesheetworkersaga/SET_ITEMS';
export const CLEAR = '@app/timesheetworkersaga/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    errorStatus: '',
    items: []
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUCCESS:
                draft.items = payload.data;
                break;
            case FAILURE:
                draft.errorStatus = payload;
                break;
            case SET_LOADING:
                draft.loading = payload;
                break;
            case CLEAR:
                draft.loading = false;
                draft.errorStatus = '';
                draft.items = [];
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    initRequest: () => creator(INIT_REUQEST),
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    /**
     * Request Saga (payload shoud be as query string)
     */
    *request({ payload }) {
        yield put(creator(SET_LOADING, true));
        try {
            const _payload = { ...payload };
            if (_payload.company) {
                delete _payload.company;
            }
            const queryString = serializeToQueryString(_payload);
            const response = yield axios.get(`/orders/timesheets/workers?${queryString}`);
            yield put(actions.success(response.data));
        } catch (e) {
            console.error(e);
            const error =
                (e.response && e.response.data && e.response.data.message) ||
                'error: Something went wrong please contact support!';
            yield put(creator(CLEAR));
            yield put(actions.failure(error));
        }

        yield put(creator(SET_LOADING, false));
    },

    *initRequest() {
        yield put(creator(SET_LOADING, true));

        try {
            const response = yield axios.get(
                `/orders/timesheets/workers?month=${CURRENT_MONTH}&year=${CURRENT_YEAR}`
            );
            yield put(actions.success(response.data));
        } catch (e) {
            console.error(e);
            const error =
                (e.response && e.response.data && e.response.data.message) ||
                'error: Something went wrong please contact support!';
            yield put(creator(CLEAR));
            yield put(actions.failure(error));
        }

        yield put(creator(SET_LOADING, false));
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
    yield takeLatest(INIT_REUQEST, sagas.initRequest);
};
